import ServiceProviderSidebar from './container'
export { ServiceProviderSidebar }
export default ServiceProviderSidebar